import {useState} from "react";
import axios from 'axios';
import {useNavigate} from 'react-router-dom'
import {useCookies} from 'react-cookie'

const AuthModal = ({setShowModal, setIsSignUp, isSignUp}) => {
    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState(null)
    const [confirmPassword, setConfirmPassword] = useState(null)
    const [error, setError] = useState(null)
    const [cookies, setCookie, removeCookie] = useCookies(['user'])
     let navigate = useNavigate()
    const handleClick = () => {
        setShowModal(false)
        // setIsSignUp(true)
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            if (isSignUp && (password !== confirmPassword)) {
                setError('Passwords does not match!')
                return
            }
            console.log('you submitted your form!')
             const response = await axios.post(`https://match-app-backend.herokuapp.com/${isSignUp?'signup':'login'}`, {

                email,
                password
            })
            setCookie('email', response.data.email)
            setCookie('UserId', response.data.userId)
            setCookie('AuthToken', response.data.token)
            const success = response.status === 201
            if (success && isSignUp) navigate('./onboarding')
            if (success && !isSignUp) navigate('./dashboard')
            window.location.reload()
        } catch (error) {
            console.log(error)
        }

    }
    return (
        <div className={'auth-modal'}>
            <div className={'close-icon'} onClick={handleClick}>
                X
            </div>
            <h2>{isSignUp ? 'Create Account' : 'Log In'}</h2>
            <form onSubmit={handleSubmit}>
                <input type="email"
                       id="email"
                       name="email"
                       placeholder={'email'}
                       required={true}
                       onChange={(e) => setEmail(e.target.value)}/>
                <input type="password"
                       id="password"
                       name="password"
                       placeholder={'password'}
                       required={true}
                       onChange={(e) => setPassword(e.target.value)}/>
                {isSignUp && <input type="password"
                                    id="password-check"
                                    name="password-check"
                                    placeholder={'password-check'}
                                    required={true}
                                    onChange={(e) => setConfirmPassword(e.target.value)}/>}
                <input type="submit" className={'secondary-button'}/>
                <p>{error}</p>
            </form>
            <hr/>
        </div>
    )
}

export default AuthModal